import _asyncToGenerator from "@babel/runtime-corejs3/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import _JSON$stringify from "@babel/runtime-corejs3/core-js-stable/json/stringify";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import { makeStyles, RaiseColors, Button, Typography, ShadowContainer, useTheme, useMediaQuery } from "componentLibrary";
import React from "react";
import * as Yup from "yup";
import LoginFormContentContainer from "./LoginFormContentContainer";
import Cookies from "js-cookie";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var useStyles = function useStyles() {
  var theme = useTheme();
  return makeStyles(function () {
    return {
      container: _defineProperty(_defineProperty(_defineProperty({
        height: "100%",
        width: "100%"
      }, theme.breakpoints.up("md"), {
        display: "flex"
      }), theme.breakpoints.down("md"), {
        paddingTop: 32,
        display: "block"
      }), "backgroundColor", RaiseColors.neutral200),
      loginContentContainer: _defineProperty({
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: RaiseColors.neutral200,
        margin: "auto"
      }, theme.breakpoints.up("md"), {
        width: "60%"
      }),
      loginContentImage: _defineProperty(_defineProperty({
        height: 48,
        width: 268
      }, theme.breakpoints.down("smMd"), {
        width: 178,
        height: 32
      }), "marginBottom", 32),
      containerHeader: {
        marginBottom: "32px",
        display: "flex",
        flexDirection: "column"
      },
      containerDiv: _defineProperty({
        padding: 32,
        width: 495
      }, theme.breakpoints.down("smMd"), {
        width: 360,
        padding: 16
      }),
      stockImage: {
        height: "100%",
        width: "40%",
        objectFit: "cover",
        backgroundColor: RaiseColors.midnight
      },
      termsDiv: _defineProperty({
        display: "flex",
        alignItems: "center",
        gap: 24,
        marginTop: 32
      }, theme.breakpoints.down("smMd"), {
        marginTop: 16
      }),
      linkText: {
        textDecoration: "none"
      },
      textField: {
        backgroundColor: RaiseColors.neutral100,
        boxShadow: "0px 0px 14px 0px ".concat(RaiseColors.midnight, "14"),
        color: RaiseColors.gray100,
        "&:hover": {
          borderColor: RaiseColors.midnight
        }
      }
    };
  });
};
var ForgetPassword = function ForgetPassword() {
  var classes = useStyles()();
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    loading = _React$useState2[0],
    setLoading = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    isError = _React$useState4[0],
    setIsError = _React$useState4[1];
  var _React$useState5 = React.useState(false),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    successful = _React$useState6[0],
    setSuccessful = _React$useState6[1];
  var _React$useState7 = React.useState(""),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    userEmail = _React$useState8[0],
    setUserEmail = _React$useState8[1];
  var _React$useState9 = React.useState("Oops ... Seems like there’s an error. Please check for typos and try again."),
    _React$useState0 = _slicedToArray(_React$useState9, 2),
    errorMessage = _React$useState0[0],
    setErrorMessage = _React$useState0[1];
  var theme = useTheme();
  var isMobile = useMediaQuery(theme.breakpoints.down("md"));
  var handleSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var userEmail, postData, response, data, _t;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            userEmail = _ref.userEmail;
            postData = {
              email: userEmail
            };
            setUserEmail(postData.email);
            setLoading(true);
            _context.prev = 1;
            _context.next = 2;
            return fetch("/ajax/accounts/request_password_reset", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "X-CSRFToken": Cookies.get("csrftoken") || ""
              },
              body: _JSON$stringify(postData)
            });
          case 2:
            response = _context.sent;
            _context.next = 3;
            return response.json();
          case 3:
            data = _context.sent;
            if (response.ok && data.successful) {
              setLoading(false);
              setSuccessful(true);
            } else {
              setLoading(false);
              setIsError(true);
            }
            _context.next = 5;
            break;
          case 4:
            _context.prev = 4;
            _t = _context["catch"](1);
            setIsError(true);
            setLoading(false);
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 4]]);
    }));
    return function handleSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var ValidationSchema = Yup.object().shape({
    userEmail: Yup.string().email("Please enter a valid email.").nullable()
  });
  var additionalFormLinks = [{
    id: "sign_in",
    label: "Sign in",
    to: "workplace_login"
  }];
  var FogetPasswordSuccessView = function FogetPasswordSuccessView() {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(ShadowContainer, {
        children: /*#__PURE__*/_jsxs("div", {
          className: classes.containerDiv,
          children: [/*#__PURE__*/_jsxs("div", {
            className: classes.containerHeader,
            children: [/*#__PURE__*/_jsx(Typography, {
              variant: "h3",
              weight: "semibold",
              children: "Recover Password"
            }), /*#__PURE__*/_jsxs(Typography, {
              variant: "paragraph_medium",
              children: ["Link has been sent to ", userEmail, "! Check your email to finish resetting your password"]
            })]
          }), /*#__PURE__*/_jsx(Button, {
            variant: "newPrimary",
            href: "/raise_login/:next",
            children: /*#__PURE__*/_jsx(Typography, {
              variant: isMobile ? "paragraph_small" : "paragraph_medium",
              weight: "medium",
              color: RaiseColors.neutral100,
              children: "Return to sign in"
            })
          })]
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: classes.termsDiv,
        children: [/*#__PURE__*/_jsx("a", {
          href: "https://www.jllt.com/legal-agreements/jllt/terms-of-service/",
          target: "_blank",
          rel: "noopener noreferrer",
          className: classes.linkText,
          children: /*#__PURE__*/_jsx(Typography, {
            color: RaiseColors.blue700,
            weight: "medium",
            variant: isMobile ? "paragraph_small" : "paragraph_medium",
            children: "Terms of Service"
          })
        }), /*#__PURE__*/_jsx("a", {
          href: "https://www.us.jll.com/en/privacy-statement",
          target: "_blank",
          rel: "noopener noreferrer",
          className: classes.linkText,
          children: /*#__PURE__*/_jsx(Typography, {
            color: RaiseColors.blue700,
            weight: "medium",
            variant: isMobile ? "paragraph_small" : "paragraph_medium",
            children: "Privacy Policy"
          })
        })]
      })]
    });
  };
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs("div", {
      className: classes.container,
      children: [/*#__PURE__*/_jsxs("div", {
        className: classes.loginContentContainer,
        children: [/*#__PURE__*/_jsx("img", {
          src: "".concat(window.STATIC_URL, "images/logos/JLL/JLL Leasing OS Logo.svg"),
          className: classes.loginContentImage
        }), successful ? /*#__PURE__*/_jsx(FogetPasswordSuccessView, {}) : /*#__PURE__*/_jsx(LoginFormContentContainer, {
          header: "Recover Password",
          subHeader: "Enter your email and we'll send you a link to reset your password",
          formElements: [{
            id: "userEmail",
            initialValue: "",
            label: "Email",
            placeholder: "Enter your email"
          }],
          ValidationSchema: ValidationSchema,
          handleSubmit: handleSubmit,
          loading: loading,
          isError: isError,
          buttonText: "Send Link",
          additionalFormLinks: additionalFormLinks,
          errorMessage: errorMessage
        })]
      }), !isMobile ? /*#__PURE__*/_jsx("img", {
        className: classes.stockImage,
        src: "".concat(window.STATIC_URL, "images/JLL Login Workspace Cover.jpg")
      }) : null]
    })
  });
};
export default ForgetPassword;